import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { predictionTrendsStore, LABEL_TRANSLATIONS } from "./PredictionTrendsStore";
import DataWindowSlider from "../components/DataWindowSlider";
import ChartsGroup from "../components/ChartsGroup";
import ComparisonChart from "../components/ComparisonChart";
import { getMarkerLabel } from "./markersDictionary";
import { useDataWindow } from '../hooks/useDataWindow';
import { toJS } from "mobx";
import debounce from 'lodash/debounce';

const INTERVAL_OPTIONS = [  
  { value: 3, label: "3 дня" },
  { value: 5, label: "5 дней" },
  { value: 7, label: "Неделя" },
  { value: 30, label: "Месяц" }
];

const MARKERS_KEY = 'selectedMarkers_topics';

const PredictionTrendsPage = observer(() => {
  // Отдельный ключ хранения для этой страницы
  const [dataWindow, updateDataWindow] = useDataWindow(100, null, 'predictionDataWindow');

  const [selectedMarkers, setSelectedMarkers] = useState(() => {
    try {
      const saved = localStorage.getItem(MARKERS_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const markerColors = useMemo(() => {
    const colors = [
      '#1976d2', '#d32f2f', '#388e3c', '#f57c00', '#7b1fa2',
      '#0288d1', '#c2185b', '#fbc02d', '#455a64', '#0097a7',
    ];
    const colorMap = {};
    console.log(selectedMarkers)
    if (selectedMarkers.length != 0){
      selectedMarkers.forEach((marker, index) => {
        colorMap[marker] = colors[index % colors.length];
      });
    }
    return colorMap;
  }, [selectedMarkers]);

  const store = predictionTrendsStore;

  const debouncedFetchStats = useMemo(    
    () => debounce((start, end) => store.fetchStats(start, end), 300),
    [store]
  );

  // Очистка дебансированной функции при размонтировании
  useEffect(() => {
    return () => {
      debouncedFetchStats.cancel();
    };
  }, [debouncedFetchStats]);

  useEffect(() => {
    if (
      store.selectedGroups.length > 0 &&
      store.startDate &&
      store.endDate
    ) {
      console.log(dataWindow.start, dataWindow.end)
      debouncedFetchStats(dataWindow.start, dataWindow.end);            
    }
    
  }, [
    store.selectedGroups.join(),
    store.startDate,
    store.endDate,
    store.interval,
    store.displayMode,
    store.selectedLabels.join(),
    store.singleLabel,
    dataWindow.start,
    dataWindow.end
  ]);

  

  // Автоматически выбирать singleLabel и selectedLabels при изменении labels
  // useEffect(() => {
  //   if (store.selectedLabels.length === 0) {
  //     const filtered = store.labels.filter(l => ["conflict, war and peace", "politics"].includes(l));
  //     store.setSelectedLabels(filtered.length > 0 ? filtered : store.labels);
  //   }
  //   if (!store.singleLabel && store.labels.length > 0) {
  //     store.setSingleLabel(store.labels[0]);
  //   }
  // }, [store.labels]);

  // Обработка выбора чекбокса группы
  const handleGroupCheckbox = (id) => {
    if (store.selectedGroups.includes(id)) {
      store.setSelectedGroups(store.selectedGroups.filter(gid => gid !== id));
    } else {
      store.setSelectedGroups([...store.selectedGroups, id]);
    }
  };

  // Обработка выбора лейблов
  const handleLabelCheckbox = (label) => {
    if (store.selectedLabels.includes(label)) {
      store.setSelectedLabels(store.selectedLabels.filter(l => l !== label));
    } else {
      store.setSelectedLabels([...store.selectedLabels, label]);
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 32 }}>
      {/* Переключатель режима */}
      <div style={{ margin: '16px 0', display: 'flex', gap: 24, alignItems: 'center' }}>
        <label style={{ fontWeight: 600 }}>Режим отображения:</label>
        <label>
          <input type="radio" value="sum" checked={store.displayMode === 'sum'} onChange={() => store.setDisplayMode('sum')} /> Суммарно по группам
        </label>
        <label>
          <input type="radio" value="split" checked={store.displayMode === 'split'} onChange={() => store.setDisplayMode('split')} /> Раздельно по группам (по одной тематике)
        </label>
        <label>
          <input type="radio" value="compare" checked={store.displayMode === 'compare'} onChange={() => store.setDisplayMode('compare')} /> Сравнение групп (по одной тематике)
        </label>
      </div>
      {/* Форма фильтров */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 24,
        alignItems: "flex-end",
        background: "#f8f9fa",
        borderRadius: 12,
        padding: 24,
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        marginTop: 24
      }}>
        <div>
          <label style={{ fontWeight: 600 }}>Агрегация:</label><br />
          <select value={store.interval} onChange={e => store.setInterval(Number(e.target.value))} style={{ borderRadius: 6, border: '1px solid #ccc', padding: 4 }}>
            {INTERVAL_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        {store.labels.length > 0 ? (
          <div>
            {store.displayMode === 'sum' ? (
              <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
                <div style={{
                  background: '#f8f9fa',
                  borderRadius: 10,
                  padding: 16,
                  boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                  maxWidth: 900,
                  width: '100%'
                }}>
                  <div style={{ marginBottom: 12, fontWeight: 600 }}>Выберите тематики для отображения:</div>
                  <div style={{
                    display: 'flex', flexWrap: 'wrap', gap: 12, maxHeight: 120, overflowY: 'auto',
                    background: '#fff', border: '1px solid #dee2e6', borderRadius: 8, padding: 8
                  }}>
                    {store.labels.map(label => (
                      <label key={label} style={{ display: 'flex', alignItems: 'center', fontSize: 15, marginRight: 16 }}>
                        <input
                          type="checkbox"
                          checked={store.selectedLabels.includes(label)}
                          onChange={() => handleLabelCheckbox(label)}
                          style={{ marginRight: 6 }}
                        />
                        {LABEL_TRANSLATIONS[label] || label}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <label style={{ fontWeight: 600 }}>Тематика:</label><br />
                <select 
                  value={store.singleLabel} 
                  onChange={e => store.setSingleLabel(e.target.value)} 
                  style={{ borderRadius: 6, border: '1px solid #ccc', padding: 4 }}
                >
                  {store.labels.map(label => (
                    <option key={label} value={label}>{LABEL_TRANSLATIONS[label] || label}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#888', margin: '24px 0', fontSize: 16 }}>
            Нет данных для отображения тематик
          </div>
        )}
      </div>
      {(store.selectedGroups.length === 0) ? (
        <p className="no-data">Выберите сообщества в верхней панели для отображения графика</p>
      ) : store.selectedLabels.length ===0 ? (
        <p className="no-data">Для отображение графика выберите тематики</p>
      ) : store.loading ? (
        <div className="no-data-message">Загрузка</div>
      ) :  store.error? (
         <div style={{ color: "red" }}>{store.error}</div>
      ) : (!store.loading && store.statsByGroup.length === 0)? (
        <div className="no-data-message">Нет данных для отображения</div>
      ) : store.displayMode === 'compare'? (
        <>
        <DataWindowSlider
          aggregation={store.interval}  
          numOfVisible={50}                             
          storageKey="predictionDataWindow"
        />   
        <ComparisonChart
          loading = {store.loading}
          chartData={toJS(store.statsByGroup)}
          dataWindow={dataWindow}
          markerColors={markerColors}
          getMarkerLabelFunction={getMarkerLabel}
          getTableDataByDate={(intervalLabel, series) => store.buildModalRowsForInterval(intervalLabel, series)}
          postCards
        />
        </>
      ):
      (
        <>
        <DataWindowSlider
          aggregation={store.interval}
          numOfVisible={100}                               
          storageKey="predictionDataWindow"
        />   
        <ChartsGroup
          loading = {store.loading}
          chartData={toJS(store.statsByGroup)}
          dataWindow={dataWindow}
          markerColors={markerColors}
          getMarkerLabelFunction={getMarkerLabel}
          getTableDataByDate={(intervalLabel, series) => store.buildModalRowsForInterval(intervalLabel, series)}
          postCards
        />
        </>
      )}
    </div>
    
  );
});

export default PredictionTrendsPage; 
